import { Observable } from "rxjs";


export declare type ContentType = 'json' | 'form' | 'multipart' | 'formData';

export declare type RequestMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface Request {
    method: RequestMethod;
    url: string;
    headers?: { [key: string]: string };
    body?: string | FormData;
}

export interface RequestResult {
    status: number;
    statusText: string;
    data: string;
    json?: <T>() => T;
    headers: string;
}


export const createRequest = function (url: string, method: RequestMethod, data?: any, contentType?: ContentType): Request {

    const request: Request = {
        method: method,
        url: url
    };

    switch (contentType) {
        case 'formData':
            request.body = data;
            break;
        case 'multipart':
            const multipartData = new FormData();
            Object.keys(data).map(k => multipartData.append(k, data[k]));
            request.body = multipartData;
            break;
        case 'form':
            const formData: Array<string> = [];
            Object.keys(data).map(k => formData.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k])));
            request.headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
            request.body = formData.join('&');
            break;
        case 'json':
            request.body = (data !== undefined) ? JSON.stringify(data) : null;
            request.headers = { 'Content-Type': 'application/json; charset=UTF-8' };
            break;
    }

    return request;
}

function parseXHRResult(xhr: XMLHttpRequest): RequestResult {
    return {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: xhr.getAllResponseHeaders(),
        data: xhr.responseText
    };
}

function errorResponse(xhr: XMLHttpRequest, message?: string, status?: number): RequestResult {
    return {
        status: status || xhr.status,
        statusText: xhr.statusText,
        headers: xhr.getAllResponseHeaders(),
        data: JSON.stringify({ Message: message || xhr.statusText })
    };
}

export const fetch = function (request: Request): Observable<RequestResult> {

    return new Observable(observer => {
        const xhr = new XMLHttpRequest();

        xhr.open(request.method, request.url, true);

        xhr.onload = evt => {
            observer.next(parseXHRResult(xhr));
        };

        xhr.onerror = evt => {
            observer.next(errorResponse(xhr, 'Failed to make request.', 1001));
        };

        xhr.ontimeout = evt => {
            observer.next(errorResponse(xhr, 'Request took longer than expected.', 1002));
        };

        if (request.headers) {
            Object.keys(request.headers).forEach(key => xhr.setRequestHeader(key, request.headers[key]));
        }

        xhr.send(request.body);
    });
}